exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switchbutton .input-group__details{min-height:0!important}.switchbutton{margin-top:10px!important}.error{background-color:#fff!important;border-color:#fff!important}.input-group__details{min-height:0!important}.switch{margin-top:10px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36a5b887","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homeBanner/homeBanner.vue
// module id = 1118
// module chunks = 0